import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { RuleObject } from 'antd/lib/form';

import { priorities } from './constants';
import { CustomSelect, FormItem } from './styles';

const { useWatch } = Form;

interface PriorityProps {
	fieldName: string[];
}

export function Priority({ fieldName }: Readonly<PriorityProps>) {
	const action = useWatch([...fieldName, 'action']);

	function validateField(_: RuleObject, value: number): Promise<void> {
		if (!!action && value === undefined) {
			return Promise.reject(I18n.get('Select a priority'));
		}

		return Promise.resolve();
	}

	return (
		<FormItem
			name={[...fieldName, 'priority']}
			rules={[
				() => ({
					validator: validateField
				})
			]}
		>
			<CustomSelect options={priorities} disabled={!action} placeholder={I18n.get('Priority')} />
		</FormItem>
	);
}
